<template>
  <UserListBody/>
</template>

<script>
// @ is an alias to /src
import UserListBody from '@/components/UserListBody.vue'

export default {
  name: 'UserListView',
  components: {
    UserListBody
  }
}
</script>
